import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6oe/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6oe/labels')
  },
  getCust (searchParams) {
    if (isMock) return generator(mocker.cust())
    let sendParams = {
      latitude: searchParams.lat + '',
      longitude: searchParams.lng + '',
      zipcode: ''
    }
    return instance().get(endpoint + '/hres6oe/cust', { params: sendParams })
  },
  getCustNoLocation (searchParams) {
    if (isMock) return generator(mocker.cust())
    let sendParams = {
      namcust: searchParams.namcust,
      codcust: searchParams.codcust,
      codprovr: searchParams.codprovr
    }
    return instance().get(endpoint + '/hres6oe/custNoLocation', { params: sendParams })
  },
  getHistory (codempid) {
    if (isMock) return generator(mocker.history())
    return instance().get(endpoint + '/hres6oe/history/' + codempid)
    // return instance().get(endpoint + '/hres6oe/history/' + '16010') // demo
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres6oe/dropdowns')
  },
  getLastCheckIn (codempid) {
    if (isMock) return generator(mocker.lastCheckIn())
    return instance().get(endpoint + '/hres6oe/lastCheckIn/' + codempid)
    // return instance().get(endpoint + '/hres6oe/lastCheckIn/' + '16010') // demo
  },
  saveCheckIn (saveParams) {
    if (isMock) return generator(mocker.saveCheckIn())
    return instance().post(endpoint + '/hres6oe/saveCheckIn', saveParams)
  },
  saveCheckInDetail (saveParams) {
    if (isMock) return generator(mocker.saveCheckInDetail())
    return instance().post(endpoint + '/hres6oe/saveCheckInDetail', saveParams)
  },
  log (params) {
    return instance().post(endpoint + '/hres6oe/log', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6oe/index.js